import { styled } from '@mui/material'

export const Surface = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.sand.main,
  padding: 24
}))
